import type { ReactNode } from 'react';
import { Skeleton } from '../ui/Skeleton';
import { Card, CardContent } from '../ui/Card';
import { cn } from '../../utils/cn';

interface Props {
  title: string;
  value?: string | number;
  detail?: ReactNode;
  loading?: boolean;
  tone?: 'default' | 'critical';
}

export function Widget({ title, value, detail, loading, tone = 'default' }: Props) {
  return (
    <Card className={cn(tone === 'critical' && 'border-destructive/40')}>
      <CardContent className="p-4">
        <h3 className="text-xs uppercase tracking-wide text-muted-foreground mb-2">{title}</h3>
        {loading ? (
          <Skeleton className="h-7 w-24" />
        ) : (
          value != null && (
            <div
              className={cn(
                'text-2xl font-semibold tabular-nums',
                tone === 'critical' && 'text-destructive'
              )}
            >
              {value}
            </div>
          )
        )}
        {detail && <div className="text-sm text-muted-foreground mt-2">{detail}</div>}
      </CardContent>
    </Card>
  );
}
